import React from 'react';
export class Herman extends React.Component {
    render() {
    window.location.href ='https://calm-pebble-01a513103.3.azurestaticapps.net/';
      return <h1>Hello, {this.props.name}</h1>;
    }
  }